import { auth, googleProvider } from "../config/firebase";
import { signInWithPopup } from "firebase/auth";
import checkWhitelist from "../functions/checkWhitelist";
import Button from 'react-bootstrap/Button';

export default function SignInButton() {
    const signInWithGoogle = async () => {
        try {
          await signInWithPopup(auth, googleProvider);
          /*checkWhitelist();*/
        } catch (err) {
          console.error(err);
        }
    };

    return(
        <div id="signInDiv">
            <Button onClick={signInWithGoogle} variant="outline-primary">
                <img width="20px" style={{marginBottom: 3, marginRight:5 }} alt="Google sign-in" src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Google_%22G%22_Logo.svg/512px-Google_%22G%22_Logo.svg.png" />
                Sign In with Google
            </Button>
        </div>
    );
}